import {useQuery} from '@tanstack/react-query'
import {useUser} from 'features/authorized/context/user'
import {UserData} from 'features/common/core/entitites'
import downloadImage from '../../utils/downloadImage'
import getQR from './api/getQR'

const useQR = () => {
    const {user} = useUser() as {user: UserData}
    const {data, isFetching} = useQuery(['qr'], () =>
        getQR(user.organization.qrId),
    )

    const onDownload = () => {
        if (!data) {
            return
        }
        downloadImage({data, name: 'qr'})
    }

    return {data: data || '', onDownload, isLoading: isFetching}
}

export default useQR
